<h1 class="product-details-title" data-cy="product-details-title-text">
  {{ 'i18n.productDetail.title' | translate }}
</h1>
<div class="mobile-claims">
  <ng-container *ngTemplateOutlet="Claims"></ng-container>
</div>
<section class="product-details-container">
  <section
    [ngClass]="{
      'general-details': !product?.isNonFood,
      'general-details-nonFood': !!product?.isNonFood,
    }"
  >
    <div
      class="tablet-desktop-claims"
      data-cy="tablet-desktop-claims-tags"
      *ngIf="claimTags?.length > 0"
    >
      <ng-container *ngTemplateOutlet="Claims"></ng-container>
    </div>
    <div class="divider" data-cy="divider-line"></div>
    <app-usf-expandable-panel
      *ngIf="product?.detail?.ingredients?.length > 0"
      title="{{ 'i18n.productDetail.additionalInfo.ingredients' | translate }}"
      [collapseContent]="false"
      [showArrow]="false"
      [fixedContent]="false"
      noBorders
    >
      <p data-cy="product-detail-ingredients-text">
        {{ product?.detail?.ingredients }}
      </p>
    </app-usf-expandable-panel>
    <div class="divider" data-cy="divider-line"></div>
    <app-usf-expandable-panel
      *ngIf="
        product?.detail?.preparationInstructions &&
        product?.detail?.preparationInstructions !== 'N/A'
      "
      title="{{
        'i18n.productDetail.additionalInfo.preparationInstructions' | translate
      }}"
      [collapseContent]="false"
      [showArrow]="true"
      noBorders
    >
      <p data-cy="product-detail-preparation-instructions-text">
        {{ product?.detail?.preparationInstructions }}
      </p>
    </app-usf-expandable-panel>
    <div class="divider" data-cy="divider-line"></div>
    <app-usf-expandable-panel
      *ngIf="
        product?.detail?.servingSuggestions &&
        product?.detail?.servingSuggestions !== 'N/A'
      "
      title="{{
        'i18n.productDetail.additionalInfo.servingSuggestions' | translate
      }}"
      [collapseContent]="false"
      [showArrow]="true"
      noBorders
    >
      <p data-cy="product-detail-servingSuggestions-text">
        {{ product?.detail?.servingSuggestions }}
      </p>
    </app-usf-expandable-panel>
    <div class="divider" data-cy="divider-line"></div>
    <app-usf-expandable-panel
      *ngIf="
        product?.detail?.handlingInstructions &&
        product?.detail?.handlingInstructions !== 'N/A'
      "
      title="{{
        'i18n.productDetail.additionalInfo.handlingInstructions' | translate
      }}"
      [collapseContent]="false"
      [showArrow]="true"
      noBorders
    >
      <p data-cy="product-detail-handlingInstructions-text">
        {{ product?.detail?.handlingInstructions }}
      </p>
    </app-usf-expandable-panel>
  </section>
  <section class="nutrition-facts" *ngIf="!product?.isNonFood">
    <app-product-detail-nutritional-info
      [isUsdaNutritionFlagOn]="isUsdaNutritionFlagOn"
      [productDetail]="product?.detail"
      [id]="'pdp-nutritional-info-' + product?.productNumber"
    ></app-product-detail-nutritional-info>
    <div class="report-discrepancies">
      <app-product-detail-report-discrepancies>
      </app-product-detail-report-discrepancies>
    </div>
  </section>
</section>
<section class="desktop-tablet-disclaimer">
  <h2 data-cy="product-detail-ingredients-allergens-nutrition-text">
    {{
      'i18n.productDetail.additionalInfo.ingredientsAllergensNutrition'
        | translate
    }}
  </h2>
  <ng-container *ngTemplateOutlet="Disclaimer"></ng-container>
</section>
<section class="mobile-disclaimer">
  <app-usf-expandable-panel
    title="{{
      'i18n.productDetail.additionalInfo.ingredientsAllergensDisclaimer'
        | translate
    }}"
    [addBottomBorder]="true"
  >
    <ng-container *ngTemplateOutlet="Disclaimer"></ng-container>
  </app-usf-expandable-panel>
</section>

<ng-template #Claims>
  <section class="claims" *ngIf="claimTags?.length > 0">
    <h2 data-cy="product-claims-text">
      {{ 'i18n.productDetail.additionalInfo.productClaims' | translate }}
    </h2>
    <div class="claim-tags">
      <app-usf-product-tag-list
        [tagList]="claimTags"
        [infoIconEnabled]="true"
        [product]="product"
      >
      </app-usf-product-tag-list>
    </div>
  </section>
</ng-template>
<ng-template #Disclaimer>
  <app-product-detail-disclaimer
    [product]="product?.detail"
  ></app-product-detail-disclaimer>
</ng-template>
